import {IoMdPin} from 'react-icons/io'
import Divider from '@components/V3/Divider'
import Pill from '@components/V3/Pill'
import Text from '@components/V3/Text'
import useInitialData from '@page-components/Layout/useInitialData'
import getStoreInMapLink from '@page-components/TrackV2/helpers/getStoreInMapLink'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import useStatus from '@page-components/TrackV2/hooks/useStatus'
import {useTranslation} from 'next-i18next'

export default function PickupDirections() {
  const {order} = useOrder()
  const status = useStatus()
  const {website} = useInitialData()
  const {t} = useTranslation('tracking', {keyPrefix: 'pickupDirections'})
  if (status !== 'readyForPickup') {
    return null
  }

  return (
    <>
      <Divider full className="mb-4" />
      <div className="flex items-center space-x-2">
        <IoMdPin size={20} />
        <div className="flex-1">
          <Text type="caption">
            {t('pickupAt', {websiteName: website.name, storeName: order.store.name})}
          </Text>
          <Text type="body">{order.store.address.address}</Text>
        </div>
      </div>
      <div className="flex justify-end">
        <Pill
          onClick={() => window.open(getStoreInMapLink(order.store))}
          primary
          className="!py-1"
          showCaret={false}>
          {t('viewMap')}
        </Pill>
      </div>
    </>
  )
}
